import script from "./WorkspaceSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkspaceSettings.vue?vue&type=script&setup=true&lang=js"

import "./WorkspaceSettings.vue?vue&type=style&index=0&id=15ff45a8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15ff45a8"]])

export default __exports__